// Registrazione service worker per PWA / funzionamento offline
export function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((reg) => {
          // Service worker registered successfully
        })
        .catch((err) => {
          // Service worker registration failed - app continues working without offline support
        });
    });
  }
}
